module.exports = __webpack_public_path__ + "img/40_38_072_740.3120aafd.jpg";